import { useQuery } from 'react-query';
import axios, { AxiosError } from 'libs/axios';
import { ABOUT_QUERY_KEY } from './query-keys';

interface Info {
    version: string;
    imageProcessingVersion: string;
    authors: string[];
}

export const useAbout = (enabled: boolean) => {
    return useQuery<Info, AxiosError>(
        ABOUT_QUERY_KEY,
        async () => {
            const response = await axios.get<Info>('/api/ui/about');
            return response.data;
        },
        {
            enabled,
            initialData: {
                version: '',
                imageProcessingVersion: '',
                authors: []
            },
            staleTime: 0,
            refetchOnWindowFocus: false
        }
    );
};
